<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
      :title="$t('text.orderCardMonitorLog')"
      :visible.sync="isShowLogDialog"
      width="1100px"
      @close="handleDialog"
  >
    <el-form
        ref="form"
        :model="search"
        label-width="50px"
    >
      <el-form-item>
        <el-radio-group
            v-model="search.field"
            @change="
            search.value = '';
            $refs.form.resetFields();
            searchData = [];
          "
        >
          <el-radio label="orderId">{{ $t("text.orderNumber") }}</el-radio>
          <el-radio label="merchantOrderId">{{ $t("text.merchantOrderNumber") }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
          prop="value"
          :rules="{ required: true, message: placeholder, trigger: 'blur' }"
          :error="search.error"
      >
        <el-input
            v-model="search.value"
            auto-complete="off"
            :placeholder="placeholder"
            @focus="search.error = ''"
            style="width: 500px"
        >
          <el-button slot="append" icon="el-icon-search" @click="logDetail"
          >{{ $t("text.searchFor") }}</el-button
          >
        </el-input>
      </el-form-item>
    </el-form>
      <hr >
    <div v-if="detail && Object.keys(detail).length" style="padding-top: 10px">
      <div class="order-number-list">
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="field-item">
              <el-tag>{{ $t("text.orderNumber") }}</el-tag>
              <span>{{ detail.orderId }}</span>
            </div>
          </el-col>

          <el-col :span="7">
            <div class="field-item">
              <el-tag type="success">{{ $t("text.merchantOrderId") }}</el-tag>
              <span>{{ detail.merchantOrderId }}</span>
            </div>
          </el-col>

          <el-col :span="10">
            <div class="field-item">
              <el-tag type="warning">{{ $t("text.orderAmount") }}</el-tag>
              <span>{{ detail.orderAmount }}</span>
            </div>
          </el-col>

          <el-col :span="7">
            <div class="field-item">
              <el-tag>{{ $t("text.customerName") }}</el-tag>
              <span>{{ detail.customerName }}</span>
            </div>
          </el-col>

          <el-col :span="7">
            <div class="field-item">
              <el-tag type="success">{{ $t("text.submittedName") }}</el-tag>
              <span>{{ detail.checkoutCustomerName }}</span>
            </div>
          </el-col>

          <el-col :span="10">
            <div class="field-item">
              <el-tag type="warning">{{ $t("text.submittedTime") }}</el-tag>
              <span>{{ $formatter.formatDate(null, null, detail.submitDate + detail.submitTime, null) }}</span>
            </div>
          </el-col>

          <el-col :span="7">
            <div class="field-item">
              <el-tag>{{ $t("text.receiverAccountType") }}</el-tag>
              <span>{{ detail.cardOrganization }}</span>
            </div>
          </el-col>

          <el-col :span="7">
            <div class="field-item">
              <el-tag type="success">{{ $t("text.cardPaymentAccount") }}</el-tag>
              <span>{{ detail.receiverAccount }}</span>
            </div>
          </el-col>

          <el-col :span="10">
            <div class="field-item">
              <el-tag type="warning">{{ $t("text.deviceId") }}</el-tag>
              <span>{{ detail.deviceId }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-table :data="logList" v-loading="loading" v-if="detail && Object.keys(detail).length">
      <el-table-column
          prop="logTime"
          width="160px"
          :label="$t('text.time')"
      ></el-table-column>
      <el-table-column :label="$t('text.receivedNotification')">
        <template slot-scope="scope">
          {{ scope.row.received.notificationMessage }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('text.customerName')" prop="customerName" width="200px"></el-table-column>

      <el-table-column :label="$t('text.amountReceived')" prop="amountReceived" width="100px"></el-table-column>

      <el-table-column :label="$t('text.log')" prop="message" ></el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleDialog">{{ $t("text.cancel") }}</el-button>
      <el-button type="primary" @click="logDetail" :loading="loading">{{
          $t("text.refresh")
        }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  props: {
    isShowLogDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: {
        field: "orderId",
        value: "",
        error: "",
        loading:false
      },
      logList: [],
      detail: [],
      form: {},
      searchData: [],
      loading: false,
    };
  },
  computed: {
    placeholder() {
      return this.search.field === "orderId"
          ? this.$t("message.inputOrderId")
          : this.search.field === "merchantOrderId"
              ? this.$t("message.inputMerchantOrderId")
              : this.$t("message.inputChannelOrderIdForQuery");
    },
    label() {
      return this.search.field === "orderId"
          ? this.$t("text.merchantOrderNumber")
          : this.search.field === "merchantOrderId"
              ? this.$t("text.merchantOrderNumber")
              : this.$t("text.channelOrderNumber");
    },
  },
  methods: {
    logDetail() {
      let params = {
        orderId: "",
        merchantOrderId: ""
      };
      params[this.search.field] = this.search.value;
      this.loading = true;
      this.$axios.get("/order/cardByOrderApiLog", {params: params }
      ).then((res) => {
        if (res.code === 200) {
          res.data.logList = res.data.logList.map(item => {
            const received = JSON.parse(item.message.replace("Received app notification: ", ""));
            const sdaPayregex = /^(.*?) sent you PKR (\d+)/;
            const oPayregex = /^You have received Rs\. (\d+\.\d{2}) from (.+?) from.*$/;
            const message = received.notificationMessage;
            const sdaPayMatch = message.match(sdaPayregex);
            const oPayMatch = message.match(oPayregex);
            let customerName = ' -- ';
            let amountReceived = ' -- ';
            if (sdaPayMatch) {
              customerName = sdaPayMatch[1];
              amountReceived = sdaPayMatch[2];
            } else if (oPayMatch) {
              customerName = oPayMatch[2];
              amountReceived = oPayMatch[1];
            }

            return {
              ...item,
              received: received,
              amountReceived: amountReceived,
              customerName: customerName
            };
          });
          console.log(res.data)
          this.detail = res.data;
          this.logList = res.data.logList;
        } else {
          this.detail = null;
          this.logList = null;
          this.$message.error('Search Fail Message: ' + res.msg);
        }
      }).catch((e) => {
        this.$message.error(e);
        console.log(e);
      }).finally(() => {
        this.loading = false;
      })
    },
    handleDialog() {
      this.$emit("update:isShowLogDialog", false);
      this.$emit("update:logDialogValue", null);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-number-list {
  display: flex;
  align-items: center;
  gap: 24px;

  span {
    display: inline-block;
    margin-left: 10px;
  }
}

.order-info-table {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-bottom: 16px;
  border-left: 1px solid #d3dce6;
  border-radius: 4px;

  th,
  td {
    border: 1px solid #d3dce6;
  }

  th {
    border-left: none;
    border-right: none;
  }

  tr {
    width: 50%;
    display: flex;
  }

  th {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    background-color: #ebeef5;
    font-weight: bold;
  }

  td {
    flex: 1;
    padding: 12px 16px;
  }

  tr:nth-child(1),
  tr:nth-child(2) {
    td {
      border-bottom: none;
    }
  }
}

.el-col {
  padding-bottom: 5px
}
</style>
